<template>
  <div class="header" v-if="channelDataFlag">
    <div class="kindhead">
        <van-tabbar v-model="active" class="header_bar">
          <div class="headerFl" v-for="(item, index) of channelData" :key="index" @click="selectMenu($event, index)">
            <van-tabbar-item :title="item.salechnlName">
              <p class="menu_text">{{ item.salechnlName }}</p>
            </van-tabbar-item>
          </div>
        </van-tabbar>
    </div>
    <div class="footer" v-if="class_flag">
      <van-tabs
        sticky
        v-model="activeindex"
        animated
        color="#008AFF"
        class="tab-warpper"
        line-width="10%"
        @click="channelClick"
      >
        <van-tab
          v-for="(item, index) of salechnlList"
          :key="index"
          :title="item.salechnlName"
        >
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
import { postAction } from '@/utils/api'
import { getUrlKey } from '@/utils/util'
import Bus from '@/utils/bus'
export default {
  name: 'bankChannel',
  data () {
    return {
      // 一级标签默认选择项active
      active: 0,
      // 二级标签默认选择项activeindex
      activeindex: 0,
      class_flag: 0,
      channelData: [],
      salechnlList: [], // 二级菜单列表
      channelNum: null,
      channelName: '',
      getUrl: '',
      getUrl1: '',
      currenIndex: null,
      channelDataFlag: false // 是否展示详情页头部指标与hasHeader搭配使用
    }
  },
  props: {
    headType: {
      type: String,
      default: null
    }
  },
  methods: {
    change (index) {
      this.active = index
    },
    getHeaderInfo () {
      var url = '/simpapp/menu/menuIndexApi'
      this.getUrl = getUrlKey('indexId', window.location.href)
      this.getUrl1 = getUrlKey('businessId', window.location.href)
      if (this.getUrl && this.getUrl1) {
        this.$store.commit('OPE_SET_KIND', this.getUrl1)
        this.$store.commit('OPE_SET_QUOTA', this.getUrl)
      }
      var postData = {
        indexCode: this.$store.state.ope.quota,
        pageCode: this.$store.state.ope.kind,
        channelCode: this.$store.state.ope.channelQuota[0],
        channelNum: this.$store.state.ope.detailChannel
      }
      var obj = postAction(url, postData)
      obj.then((res) => {
        // 用返回数据中的hasHeader指标控制详情页头部导航是否显示(0无1存在)，用绑定指标channelDataFlag布尔值判别
        if (res.data.hasHeader === '0') {
          this.channelDataFlag = false
        } else {
          this.channelDataFlag = true
        }
        this.channelData = res.data.salechnl
        this.saleData = res.data.salechnl[0].children
        this.channelNum = this.$store.state.ope.detailChannel
          ? this.$store.state.ope.detailChannel
          : this.$store.state.ope.channel
        let selectedData = this.getChannelData()
        this.channelNum =
          selectedData !== false
            ? selectedData.dataSalechnlCode
            : this.channelData[0].dataSalechnlCode
        this.$store.commit('OPE_SET_DETAIL_CHANNEL', this.channelNum)
        var channelQuota = []
        this.$store.commit('OPE_SET_CHANNEL_QUOTA', channelQuota)
        channelQuota.push(this.channelNum)
        channelQuota.push(this.$store.state.ope.quota)
        this.$store.commit('OPE_SET_CHANNEL_QUOTA', channelQuota)
      })
    },
    onChange (event, index) {
      console.log('dfsdfsdfsdf', event)
      /** event.detail 的值为当前选中项的索引
      * 如果一级菜单发生变化或为选中一级菜单，则二级菜单是否显示项class_flag变为1
      * 如果一级菜单发生变化或为选中一级菜单，则二级菜单选中项重置 【this.activeindex = 0;】
      * 如果一级菜单发生变化或为选中一级菜单，二级菜单项动态更换为salechnlList 【this.salechnlList = this.channelData[event].children;】
      */
      console.log(`一级菜单发生变化或为选中，现在选中的下标是${event}`)
      if (event === 0 || event === 1) {
        this.class_flag = 1
      }
      this.activeindex = 0
      this.salechnlList = this.channelData[event].children
      let singleData = this.channelData[event]
      this.$store.commit('OPE_SET_DETAIL_CHANNEL', singleData.dataSalechnlCode)
      Bus.$emit('menuIndex', 0)
      this.currenIndex = event
    },
    // 点击弹出二级菜单
    channelClick (data) {
      console.log(`二级菜单变化了，现在选中的下标是${data}`)
      let salechnlData = this.salechnlList[data]
      this.$store.commit('OPE_SET_DETAIL_CHANNEL', salechnlData.dataSalechnlCode)
      Bus.$emit('menuIndex', data)
    },
    getChannelData () {
      for (let i = 0; i < this.channelData.length; i++) {
        if (this.channelData[i].dataSalechnlCode === this.channelNum) {
          return this.channelData[i]
        }
      }
      return false
    },
    // 点击header
    selectMenu (event, index) {
      if (index === this.currenIndex) {
        // 初始化数据active=0默认选中第一个业务类型，置为空默认不选中
        this.active = index
        this.currenIndex = null
        this.class_flag = 0
        this.activeindex = 0
        let singleData = this.channelData[0]
        this.$store.commit('OPE_SET_DETAIL_CHANNEL', singleData.dataSalechnlCode)
      } else {
        this.onChange(index)
      }
      console.log(index)
      this.time = this.$store.state.ope.time
      console.log(this.time)
      if (this.time === 3) {
        $('.ratevalue-value span').css('marginLeft', '0rem')
      } else {
        $('.ratevalue-value span').css('marginLeft', '0rem')
      }
    }
  },
  computed: {
  },
  watch: {
    headType () {
      // indexcode指标
      console.log(this.headType)
      // 进入详情页默认选中的指标位置（犹豫期内和保单15日）
      if (this.headType === 'D0104-1005' || this.headType === 'D0104-1001') {
        this.active = 0
      } else {
        this.active = 3
      }
    }
  },
  mounted () {
    this.getHeaderInfo()
    Bus.$on('channelData', (val) => {
      this.channelData = val
      this.channelNum = this.$store.state.ope.detailChannel
      let data = this.channelData.forEach(item => {
        if (this.channelNum === 'B501' && val.length === 4) {
          this.active = 0
        } else {
          this.active = this.active
        }
      })
      console.log(data)
    })
  }
}
</script>
<style lang="stylus" scoped>
>>>.van-tabbar-item--active{
  font-weight: 400;
  font-size: 0.16rem !important;
}
.van-tabbar-item{
  font-size:0.16rem
}
.header>>>.van-tab span
  font-size 0.14rem
  line-height 3
  font-weight 400
  color #999
  // font-family:SFUIText-Medium;
.van-tab__pane
  font-size 0.16rem
  line-height 3
  font-weight 400
  color #999
.header>>>.van-tab
  color #fff
.header>>>.van-tab--active span
  color #008AFF
.header>>>.van-tabs__nav--line
  padding-bottom 0rem;
  padding-right: 0.3rem;
.header>>>.van-tabs__line
  bottom 0
  border-radius 100px 100px 0px 0px
.header>>>.van-tabs--line .van-tabs__wrap
  height auto
.header
  display flex
  width 100%
  flex-direction column
.tab-warpper
  width 100%
  flex 6
.tab-warpper .nav-title
  font-size 5rem
  color red
.header>>>.van-icon
  position absolute
  left 385px
  top 16px
  bottom 0px
  right 0
.header>>>.van-overlay
  position fixed
  top 55px !important
  left 0
  width 100%
  height 100% !important
  background-color rgba(0, 0, 0, 0.4)
.van-dialog
  position fixed
  top 2.25rem !important
  left 50%
  width 100%
  overflow hidden
  font-size 16px
  background-color #fff
  border-radius 4px
.van-cell-group
  background-color #fff
  line-height 0.4rem
.van-cell-group span
  font-size 0.12rem
  display inline-block
  background-color #f9f9f9
  color #666
  line-height 0.25rem
  padding-left 0.2rem
  padding-right 0.2rem
  margin-left 0.1rem
.van-hairline--top-bottom
  position static
.header>>>.van-dialog__footer--buttons
  display -webkit-box
  display -webkit-flex
  display flex
  margin-top 0.1rem
.header>>>.van-dialog__confirm, .van-dialog__confirm:active
  color #FFFFFF
  background-color #1989fa
.header>>>.van-dialog__cancel .van-button__text
  color #BDBDBD
.more
  text-align right
  padding-right 0.3rem
  color #999
  font-size 0.14rem
  height 0.48rem
  line-height 0.48rem
  background #fff
  flex 3
.van-cell-group span.channelClass
  background #39f
  border 1px solid #39f
  color #fff
.headerKind
  display flex
  width 100%
  background #fff
  font-size 0.14rem
  text-align center
  line-height 0.4rem
.kindClass
  color #3399FF
.kindhead
  flex 1
  display flex
.headerFl
  flex 1
  align-self center
</style>



// WEBPACK FOOTER //
// src/pages/operate/components/DetailHeader.vue